import { useFacility } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  facilityName?: string
  onClose: () => void
}

export const RemoveFacility = ({ onClose, facilityName, id }: Props) => {
  const { deleteFacility } = useFacility({})
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async () => {
    if (!id) return
    setIsLoading(true)
    try {
      await deleteFacility(id)
      showToast('Facility removed successfully')
      onClose()
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const namePart = facilityName?.trim() ? ` “${facilityName.trim()}”` : ''
  const description = `Are you sure you want to remove this facility${namePart}? This action cannot be undone.`

  return (
    <DeleteModal
      description={description}
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      rBtnLabel="Yes, Remove"
      title="Remove Facility"
    />
  )
}

export default RemoveFacility
